@if (visible$ | async) {
  <button
    type="button"
    class="floating-survey"
    mat-fab
    color="primary"
    [matTooltip]="'encuesta_pendiente' | translate"
    matTooltipClass="colortooltip"
    matBadge="1"
    matBadgeColor="warn"
    matBadgeSize="medium"
    matBadgePosition="above before"
    matBadgeOverlap="true"
    [attr.aria-label]="'encuesta_pendiente' | translate"
    (click)="onClick()"
  >
    <mat-icon class="floating-survey__icon" fontSet="material-symbols-outlined" aria-hidden="true">rate_review</mat-icon>
  </button>
}
